import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getDocuments = (axios: IAxiosInstance) => {
  return async (params: ISchema["#/definitions/TGetDocumentsParams"]) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/TGetDocumentsResponse"]
    >(`/api/getDocuments`, {
      params,
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
